import { Injectable } from '@angular/core';

import { Widget, WidgetPage } from '@frontend/sports/types/components/widget';

@Injectable({ providedIn: 'root' })
export class WidgetPageService {
    page: WidgetPage | null = null;
    top: Widget<unknown>[] = [];
    left: Widget<unknown>[] = [];
    center: Widget<unknown>[] = [];

    setActivePage({ page, top, left, center }: { page: WidgetPage; top: Widget<unknown>[]; left: Widget<unknown>[]; center: Widget<unknown>[] }) {
        this.page = page;
        this.top = top;
        this.left = left;
        this.center = center;
    }

    reset() {
        this.page = null;
        this.top = [];
        this.left = [];
        this.center = [];
    }
}
